import { Card, ToggleButton, ToggleButtonGroup } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiButton from "components/VuiButton";
import VuiTypography from "components/VuiTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import useCommon from "hooks/useCommon";
import React, { useEffect, useState } from "react";
import HotelSelector from "components/HotelSelector";
import Snackbar from "components/Snackbar";
import VuiInput from "components/VuiInput";
import GuestLibraryTable from "./components/GuestLibraryTable";
import { FaThLarge, FaList, FaTrashRestore } from "react-icons/fa";
import { getRemovedGuestDeletionSummary } from "store/slice/guestSlice";

const GuestLibrary = () => {
  const { DISPATCH, NAVIGATE, STORE } = useCommon();

  const hotelIds = STORE((state) => state.ui.hotelIds);

  const [search, setSearch] = useState("");
  const [view, setView] = useState("table");

  const { removedGuestsSummary, removedGuestsSummaryLoading, deleteGuestSuccess } = STORE(
    (state) => state.guests
  );

  const removedGuestsCount = removedGuestsSummary?.total || removedGuestsSummary?.count || 0;

  const handleOpenRemovedGuests = () => {
    NAVIGATE("/guestLibrary/removed");
  };

  const [snackbar, setSnackbar] = useState({
    show: false,
    color: "success",
    title: "",
    content: "",
    icon: "check",
  });

  const showSnackbar = ({ color, title, content, icon = "check" }) => {
    setSnackbar({
      show: true,
      color,
      title,
      content,
      icon,
    });
  };

  const closeSnackbar = () => setSnackbar((prev) => ({ ...prev, show: false }));

  useEffect(() => {
    if (!hotelIds?.length) return;

    DISPATCH(
      getRemovedGuestDeletionSummary({
        hotelIds,
      })
    );
  }, [hotelIds, deleteGuestSuccess, DISPATCH]);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <VuiBox>
        <VuiBox py={1}>
          <VuiBox mb={3}>
            <Card>
              <VuiBox mb="22px">
                {/* ===== Desktop ===== */}
                <VuiBox
                  display={{ xs: "none", md: "flex" }}
                  gap={2}
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <VuiTypography variant="lg">Guest Library</VuiTypography>

                  <VuiBox display="flex" gap={1} alignItems="center">
                    {!removedGuestsSummaryLoading && removedGuestsCount > 0 && (
                      <VuiButton
                        size="small"
                        variant="outlined"
                        color="primary"
                        onClick={handleOpenRemovedGuests}
                        startIcon={<FaTrashRestore size={12} />}
                        sx={{
                          minWidth: "unset",
                          px: 2,
                          height: 38,
                          textTransform: "none",
                          whiteSpace: "nowrap",
                          fontWeight: "regular",
                          border: "1px solid rgba(255,255,255,0.14)",
                        }}
                      >
                        Deletion Queue
                        <VuiBox
                          ml={1}
                          px={0.9}
                          py={0.15}
                          borderRadius="10px"
                          sx={{
                            background: "rgba(255,255,255,0.12)",
                            lineHeight: 1.2,
                            minWidth: 22,
                            textAlign: "center",
                          }}
                        >
                          <VuiTypography variant="caption" fontWeight="regular">
                            {removedGuestsCount}
                          </VuiTypography>
                        </VuiBox>
                      </VuiButton>
                    )}

                    <HotelSelector />

                    <VuiBox sx={{ width: "240px" }}>
                      <VuiInput
                        gradient
                        fullWidth
                        placeholder="Search guests (name, email, phone)..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </VuiBox>
                  </VuiBox>
                </VuiBox>

                {/* ===== Mobile ===== */}
                <VuiBox display={{ xs: "block", md: "none" }}>
                  <VuiTypography variant="lg" sx={{ mb: 1 }}>
                    Guest Library
                  </VuiTypography>

                  {!removedGuestsSummaryLoading && removedGuestsCount > 0 && (
                    <VuiBox mb={1.5}>
                      <VuiButton
                        fullWidth
                        size="small"
                        variant="outlined"
                        color="warning"
                        onClick={handleOpenRemovedGuests}
                        startIcon={<FaTrashRestore size={12} />}
                        sx={{
                          height: 38,
                          borderRadius: "14px",
                          textTransform: "none",
                          justifyContent: "center",
                          whiteSpace: "nowrap",
                          px: 2,
                        }}
                      >
                        {`Deletion Queue (${removedGuestsCount})`}
                      </VuiButton>
                    </VuiBox>
                  )}

                  <VuiBox mb={2}>
                    <HotelSelector minWidth={250} />
                  </VuiBox>

                  <VuiBox display="flex" gap={1}>
                    <VuiInput
                      fullWidth
                      placeholder="Search guests..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      gradient
                    />
                  </VuiBox>
                </VuiBox>
              </VuiBox>

              <VuiBox
                sx={{
                  "& th": {
                    borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                      `${borderWidth[1]} solid ${grey[700]}`,
                  },
                  "& .MuiTableRow-root:not(:last-child)": {
                    "& td": {
                      borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                        `${borderWidth[1]} solid ${grey[700]}`,
                    },
                  },
                }}
              >
                {view === "table" ? (
                  <GuestLibraryTable search={search} handleNotify={showSnackbar} />
                ) : (
                  <></>
                  //   <GuestLibraryCards
                  //     search={search}
                  //     handleNotify={showSnackbar}
                  //   />
                )}
              </VuiBox>
            </Card>
          </VuiBox>
        </VuiBox>
      </VuiBox>

      <Snackbar
        color={snackbar.color}
        icon={snackbar.icon}
        title={snackbar.title}
        content={snackbar.content}
        open={snackbar.show}
        onClose={closeSnackbar}
        close={closeSnackbar}
      />
    </DashboardLayout>
  );
};

export default GuestLibrary;
